import { NextPage, GetStaticProps } from 'next';
import Genres from '@/components/screens/genres/Genres';
import { API_URL, GENRES_FOR_PAGE, REVALIDATE_TIME } from '@/helpers/variables';
import { IGenresAll } from '@/interfaces/genres.interface';

interface IGenresPageProps {
  genres: IGenresAll;
}

const GenresPage: NextPage<IGenresPageProps> = ({ genres }) => {
  return <Genres genres={genres} />;
};

export const getStaticProps: GetStaticProps = async () => {
  const [genresRes] = await Promise.all([fetch(`${API_URL}satellite/genres/all?page=1&page_size=${GENRES_FOR_PAGE}`)]);
  const [genres] = await Promise.all([genresRes.json()]);

  return { props: { genres }, revalidate: REVALIDATE_TIME };
};

export default GenresPage;
